import React, { Fragment, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantThresholds.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelVariantThreshold from './ModelVariantThreshold';
import { useSelector } from 'react-redux';
import { getModelVariantManager } from '../../selectors/index';
import Cookies from 'js-cookie';

const ModelThresholdsListTable = ({
  setEditHandler,
  defaultThresholdHandler,
  selectedModelId,
  selectedModelThresholdId,
  selectedModelVariantId,
  selectedModelCategoryId,
  saveModelThreshold,
  modelThreshold,
  describeModelThreshold,
  changeModelThreshold,
  paginatedData = [],
  modelComponentPositions,
  disableMode,
  disableModeHandler,
  UpdateAllowed
}) => {

  const modelVariantManager = useSelector(state => getModelVariantManager(state));
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const fetchDataHandler = ModelThresholdId => {
    setEditHandler(ModelThresholdId);
    disableModeHandler(true);
    describeModelThreshold(ModelThresholdId, selectedModelVariantId, selectedModelCategoryId);
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };
  useLayoutEffect(() => {
    if (disableMode) {
      const scrollPos = window.scrollY + window.innerHeight;
      window.scrollTo(0, scrollPos);
    }
  }, [disableMode]);
  const editModelContent = (
    <ModelVariantThreshold
      selectedModelId={selectedModelId}
      selectedModelThresholdId={selectedModelThresholdId}
      ModelCategoryId={selectedModelCategoryId}
      selectedModelVariantId={selectedModelVariantId}
      saveModelThreshold={saveModelThreshold}
      modelThreshold={modelThreshold}
      changeModelThreshold={changeModelThreshold}
      modelComponentPositions={modelComponentPositions}
      defaultThresholdHandler={defaultThresholdHandler}
      cancelHandler={cancelHandler}
    />
  );

  const isModelVariantOwner = () => {
    const modelVariantOrgId = (modelVariantManager.selectedModelVariant ? modelVariantManager.selectedModelVariant.OrganisationId : '') || '';
    const userOrgId = Cookies.get(`selectedorganisationid-${envName}`) || 1;

    if (modelVariantOrgId === parseInt(userOrgId)) {
      return true
    }

    return false;
  }

  let editorMain = (
    <tr>
      <td colSpan="12">{editModelContent}</td>
    </tr>
  );

  let newRowClass = modelThreshold.showAddEditScreen && selectedModelThresholdId === 0 ? s.newRow : '';
  return (
    <div className={s.wsTableContainer}>
      <Table className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="general.sequence" defaultMessage="Sequence" />
            </th>
            <th>
              <FormattedMessage id="general.component" defaultMessage="Component" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="threshold.thresholdUnitOfMeasure" defaultMessage="Unit Of Measure" />
            </th>
            <th className="d-none d-md-table-cell">
              <span>
                <FormattedMessage id="threshold.thresholdLowLow" defaultMessage="Low Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdLow" defaultMessage="Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdOpLow" defaultMessage="Op Low" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                <FormattedMessage id="threshold.thresholdOpHigh" defaultMessage="Op High" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span >
                {' '}
                <FormattedMessage id="threshold.thresholdHigh" defaultMessage="High" />
              </span>
            </th>
            <th className="d-none d-md-table-cell">
              <span>
                <FormattedMessage id="threshold.thresholdHighHigh" defaultMessage="High High" />
              </span>
            </th>
            {(UpdateAllowed && isModelVariantOwner()) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelThresholdId}>
                <tr key={n.ModelThresholdId} data-unittest="thresholdsData">
                  <td>{n.FlowSequence}</td>
                  <td>{n.ModelComponentName}</td>
                  <td className="d-none d-md-table-cell">{n.UnitOfMeasure}</td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.red}>{n.Min}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.orange}>{n.CriticalLow}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.green}>{n.Low}</span>{' '}
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.green}>{n.High}</span>{' '}
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.orange}>{n.CriticalHigh}</span>
                  </td>
                  <td className="d-none d-md-table-cell">
                    <span className={s.red}>{n.Max}</span>
                  </td>
                  {(UpdateAllowed  && isModelVariantOwner()) && (
                    <td className={s.btnCol}>
                      {n.IsEditable && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={fetchDataHandler.bind(this, n.ModelThresholdId)}
                          disabled={disableMode}
                          data-unittest="btnChange"
                        >
                          <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
                {modelThreshold.showAddEditScreen && selectedModelThresholdId === n.ModelThresholdId && editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div className={newRowClass}>
        {modelThreshold.showAddEditScreen && selectedModelThresholdId === 0 && editModelContent}
      </div>
    </div>
  );
};

ModelThresholdsListTable.propTypes = {
  describeModelThreshold: PropTypes.func.isRequired,
  changeModelThreshold: PropTypes.func.isRequired
};

export default injectIntl(ModelThresholdsListTable);
